import { FormControl, ValidatorFn } from '@angular/forms';

export const noWhitespaceValidator: ValidatorFn = (control: FormControl) => {
  const isWhitespace =
    (control.value || '').trim().length === 0 &&
    (control.value || '').length !== 0;
  const isValid = !isWhitespace;
  return isValid ? null : { whitespace: true };
};
